/**
 * TurfScore global DOM utilities — single webpack entry: project/global/utils.bundle
 *
 * FOR AI ASSISTANTS / FUTURE CONTRIBUTORS:
 * - Add small, site-wide DOM helpers here (loaded from base.html on every page).
 * - Do NOT create additional webpack entries under project/global/ — add a module
 *   file in this folder, export an initX(root) function, import it below, and call
 *   it from initGlobalUtils().
 * - Page-specific or heavy JS (maps, uploads) stays in dedicated bundles under
 *   project/maps/ or project/uploads/ with {% render_bundle %} on that page only.
 * - Each init accepts `root` (Element | Document) so HTMX swaps can re-run:
 *   window.AppUtils.initAll(event.detail.target)
 * - Avoid inline <script> in Django templates when the behavior can live here.
 */
import { initUtcDatetimes } from "./utc_datetimes.js";
import { initActionConfirmModals } from "./action_confirm_modals.js";

export function initGlobalUtils(root) {
  initUtcDatetimes(root);
  initActionConfirmModals(root);
}

document.addEventListener("DOMContentLoaded", function () {
  initGlobalUtils(document);
});

document.addEventListener("htmx:afterSwap", function (event) {
  if (event.detail && event.detail.target) {
    initGlobalUtils(event.detail.target);
  }
});

window.AppUtils = {
  initUtcDatetimes,
  initActionConfirmModals,
  initAll: initGlobalUtils,
};
